import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const nav = css`
  display: none;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: block;
      padding: 0 ${spacing.xl}px;
      border-bottom: 1px solid var(--neutral-black-30);
    `,
  )};
`;

/* used in static HTML to occupy empty space ready for client render of nav */
export const placeholder = css`
  ${mediaQuery(
    { min: minBreakpoints.L, max: maxBreakpoints.L },
    css`
      min-height: 43px;
    `,
  )};
  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      min-height: 47px;
    `,
  )};
`;

export const list = css`
  list-style-type: none;
  max-width: ${pxToRem(minBreakpoints.XL)};
  display: flex;
  margin: 0 auto;
  padding: 0;
  justify-content: center;
`;
